import NotificationModel from 'core/src/models/notification';

const NotificationsCollection = Backbone.Collection.extend({

  model: NotificationModel,

  path: '/notifications',

  fetchMoreOptions: {
    update: true,
    remove: false,
  },

  url: function() {
    let url = this.path;
    const paramString = $.param(this.params);

    if (paramString !== '') {
      url += '?' + paramString;
    }

    return url;
  },

  initialize: function(models, options = {}) {
    this.cursor = options.cursor || -1;
    this.groupType = options.groupType || 'notification';
    this.loadMore = options.loadMore || true;
    this.params = options.params || {};
    this.classActivityTab = options.classActivityTab || false;
    this.fetchMoreOptions.success = function(collection, response) {
      options.success(collection, response, options);
    };

    this.fetchMoreOptions.error = function(collection, xhr) {
      options.error(collection, xhr);
    };
  },

  parse: function(response) {
    if (this.classActivityTab) {
      this.cursor = response.nextCursorTeach;
      this.loadMore = response.loadMoreTeach;
      return response.teacherNotifications;
    }
    this.cursor = response.nextCursorReg;
    this.loadMore = response.loadMoreReg;
    return response.notifications;
  },

  fetch: function(opts) {
    if (this.cursor === null) {
      return;
    }

    const options = _.extend(opts || {}, this.fetchMoreOptions);

    options.data = _.extend(options.data || {}, {
      cursor: this.cursor,
      group_type: this.groupType,
    });

    return Backbone.Collection.prototype.fetch.call(this, options);
  },

  fetchSet: function() {
    return this.fetch();
  },

  fetchMore: function() {
    return this.fetch();
  },

});

export default NotificationsCollection;

